<template>
  <div id="UpdatePassword" class="card">
    <div class="card-body">
      <div v-if="loginError" class="alert alert-danger">Ha ocurrido un error al actualizar tu contraseña. Inténtalo de nuevo.</div>
      <div class="text-center mb-4 mt-1">
        <img alt="Vue logo" height="60" src="../../../assets/logo-rentik.svg">
      </div>
      <form @submit.prevent="submit()">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="username">Usuario</label>
              <input type="text" class="form-control" id="username" v-model.trim="v$.username.$model">
              <div v-if="v$.username.$dirty">
                <small class="form-text text-danger" v-if="!v$.username.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="oldPassword">Contraseña antigua</label>
              <input type="password" class="form-control" id="oldPassword" v-model.trim="v$.oldPassword.$model">
              <div v-if="v$.oldPassword.$dirty">
                <small class="form-text text-danger" v-if="!v$.oldPassword.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="newPassword">Contraseña nueva</label>
              <input type="password" class="form-control" id="newPassword" v-model.trim="v$.newPassword.$model">
              <div v-if="v$.newPassword.$dirty">
                <small class="form-text text-danger" v-if="!v$.newPassword.required">Campo requerido</small>
                <small class="form-text text-danger" v-if="!v$.newPassword.minLength">La contraseña debe tener una longitud mínima de 8 caracteres</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="rNewPassword">Repite contraseña nueva</label>
              <input type="password" class="form-control" id="rNewPassword" v-model.trim="v$.rNewPassword.$model">
              <div v-if="v$.rNewPassword.$dirty">
                <small class="form-text text-danger" v-if="!v$.rNewPassword.required">Campo requerido</small>
                <small class="form-text text-danger" v-if="v$.rNewPassword.sameAsPassword.$invalid && !v$.rNewPassword.required.$invalid">Las contraseñas no coinciden</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <button class="btn btn-primary" v-bind:class="{ disabled: v$.$invalid }" :disabled="v$.$invalid" @click="submit()">Cambiar contraseña</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, sameAs, minLength } from '@vuelidate/validators'
import axios from 'axios';

export default {
  name: 'UpdatePassword',
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      username: '',
      oldPassword: '',
      newPassword: '',
      rNewPassword: '',
      loginError: false
    };
  },

  validations () {
    return {
      username: {
        required
      },
      oldPassword: {
        required,
      },
      newPassword: {
        required,
        minLength: minLength(8),
      },
      rNewPassword: {
        required,
        sameAsPassword: sameAs(this.newPassword),
      },
    }
  },

  methods: {

    submit() {
      const bodyToSend = {
        username: this.username,
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        userType: "BACKOFFICE"
      }
      axios.post('/user/updatePassword', bodyToSend)
        .then((response) => {
          console.log(response);
          this.$router.push({ name: 'login' })
        })
        .catch((error) => {
          if(error.response.data.status == 'BAD_CREDENTIALS'){
            this.loginError = true;
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
